import React from 'react'
import { Link } from 'gatsby'
import Image from '../../../image'
import { BlogThumb } from './thumbnail.stc'

const Thumbnail = ({ image, path, title }) => {
	return (
		<BlogThumb>
			<Link to={path}>
				<Image src={image} alt={title} />
			</Link>
		</BlogThumb>
	)
}

Thumbnail.defaultProps = {
	image: {}
}

export default Thumbnail
